exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".categorySummary.hasChildren .blockRow[data-v-06c291b6]{padding-bottom:.125rem}.flexRow[data-v-06c291b6]{align-items:baseline}.flexRow.categorySummary[data-v-06c291b6]{flex-wrap:nowrap}.staticBlockRow[data-v-06c291b6]{max-width:600px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-06c291b6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/CumulativeWeekView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-06c291b6&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/CumulativeWeekView.vue
// module chunks = 0